<template>
  <zi-row class="action-filter-row" justify="start" align="top">
    <div class="zi-card action-filter">
      Vanaf
      <datetime
        v-model="from"
        format="dd-MM-yyyy"
        :min-datetime="minDate"
        :max-datetime="max.toISOString()"
      ></datetime>tot
      <datetime
        v-model="to"
        format="dd-MM-yyyy"
        min-datetime="minDate"
        :max-datetime="max.toISOString()"
      ></datetime>

      <zi-button size="small" auto @click="setFilterFor('month')">Deze maand</zi-button>
      <zi-button size="small" auto @click="setFilterFor('quarter')">Dit kwartaal</zi-button>
      <zi-button size="small" auto @click="setFilterFor('prev-quarter')">Vorig kwartaal</zi-button>
      <zi-button size="small" auto @click="setFilterFor('half-year')">Afgelopen 6 maand</zi-button>
      <zi-button size="small" auto @click="setFilterFor('year')">Dit jaar</zi-button>
    </div>
  </zi-row>
</template>

<script>
import dayjs from 'dayjs'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'

dayjs.extend(quarterOfYear)

export default {
  name: 'DashboardSelectPeriod',
  computed: {
    project() {
      return this.$store.getters.project
    },
    minDate() {
      return dayjs(this.project.created_at)
        .set('hour', 0)
        .set('minute', 0)
        .set('second', 0)
        .toISOString()
    },
    from: {
      get() {
        return (
          this.$route.query.from ||
          dayjs(this.project.created_at)
            .set('hour', 0)
            .set('minute', 0)
            .set('second', 0)
            .format('YYYY-MM-DD')
        )
      },
      set(val) {
        if (val && val.length > 10) {
          val = dayjs(val).format('YYYY-MM-DD')
        }
        if (this.$route.query.from !== val) {
          this.$router.push({ query: { ...this.$route.query, from: val } })
        }
      },
    },
    to: {
      get() {
        return this.$route.query.to || dayjs().format('YYYY-MM-DD')
      },
      set(val) {
        if (val && val.length > 10) {
          val = dayjs(val).format('YYYY-MM-DD')
        }
        if (this.$route.query.to !== val) {
          this.$router.push({ query: { ...this.$route.query, to: val } })
        }
      },
    },
  },
  data: () => ({
    max: dayjs(),
  }),
  watch: {
    '$route.query'() {
      this.$store.commit('FILTER_CHANGED', this.$route.query)
    },
  },
  methods: {
    setFilterFor(range) {
      let newFrom = null
      let today = dayjs()
        .set('hour', 0)
        .set('minute', 0)
        .set('second', 0)

      if (range === 'month') {
        newFrom = today.startOf('month')
      } else if (range === 'half-year') {
        newFrom = today.subtract(6, 'month')
      } else if (range === 'quarter') {
        newFrom = today.startOf('quarter')
      } else if (range === 'prev-quarter') {
        newFrom = today.subtract(3, 'month').startOf('quarter')
      } else if (range === 'year') {
        newFrom = today.startOf('year')
      }

      this.$router.push({
        query: {
          to: today.format('YYYY-MM-DD'),
          from: newFrom.format('YYYY-MM-DD'),
        },
      })
    },
  },
}
</script>

<style>
.action-filter-row {
  padding: 20px !important;
  flex-direction: column;
}
.action-filter {
  display: flex;
  align-items: center;
}
.action-filter > * {
  margin: 0 5px;
}
.vdatetime-input {
    width: 100px;
}
</style>